import TextArea from '../TextArea'

const MLTextArea = ({ formHandler, name, isRequired = true, defaultValue }) => {
    const { formValues, handleFormValues } = formHandler

    const handleValue = (value, valueName) => {
        handleFormValues(valueName, { value, isRequired, isError:false })
    }


    console.log(defaultValue)
    return (
        <div className="row col-12">
            <TextArea
                label={name}
                lang='Ar'
                isRequired={isRequired}
                isError={formValues[name]?.isError}
                defaultValue={defaultValue?.[name]}
                value={formValues[name]?.value || ''}
                setValue={(value) => handleValue(value, name)}
                className="col-md-6"
            />
            <TextArea
                label={`${name}En`}
                lang='En'
                defaultValue={defaultValue?.[`${name}EN`]}
                isRequired={isRequired}
                isError={formValues[`${name}En`]?.isError}
                value={formValues[`${name}En`]?.value || ''}
                setValue={(value) => handleValue(value, `${name}En`)}
                className="col-md-6"
            />
        </div>
    )
}

export default MLTextArea